/**
 * The settings gear is only shown when the user can actually access at least
 * one configuration tab. A tab is accessible when the user has its required
 * resource (if any) AND one of its required JWT roles (if any); tabs without
 * requirements are accessible to everyone.
 */
export const shouldShowSettingsIcon = (
    tabs: { resource?: string; roles?: string[] }[],
    userResources: string[],
    userRoles: string[] = []
): boolean =>
    tabs.some(tab => {
        if (tab.resource && !userResources.includes(tab.resource)) return false;
        if (tab.roles && !tab.roles.some(role => userRoles.includes(role))) return false;
        return true;
    });
